module.exports = __webpack_public_path__ + "media/images/front/treatment_support/logo02-829314218f5eec651a39b89ef46c74ae.svg";